import { Card, CardContent, Fade, Hidden, makeStyles } from '@material-ui/core';
import LoginForm from './LoginForm';
import LoginBrand from './LoginBrand';

const useStyles = makeStyles((theme) => ({
  card: {
    [theme.breakpoints.down('xs')]: {
      flex: '0 0 80%',
    },
    [theme.breakpoints.down('sm')]: {
      flex: '0 0 385px',
    },
    [theme.breakpoints.up('md')]: {
      flex: '0 0 650px',
      marginLeft: '90px',
    },
    borderRadius: 0,
    boxShadow: theme.shadows[1]
  },
  cardContent: {
    display: 'flex',
    padding: '0px',
    '&:last-child': {
      paddingBottom: 0
    }
  },
  root: {
    height: '100vh',
    background: '#232526',
    background: `linear-gradient(to right, ${theme.palette.background.default} 0%, ${theme.palette.background.default} 50%, #232526 50%, #414345 100%)`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
}));

export default function LoginView(props) {
  const classes = useStyles();

  return (
    <div
      className={classes.root}
    >
      <Fade in={true} mountOnEnter unmountOnExit>
        <Card
          className={classes.card}
          variant="elevation"
        >
          <CardContent className={classes.cardContent}>
            <Hidden smDown>
              <LoginBrand />
            </Hidden>
            <LoginForm />
          </CardContent>
        </Card>
      </Fade>
    </div>
  );
};